import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import Footer from "../../examples/Footer";
import TextField from "@mui/material/TextField";
import Button from "../../components/ButtonUse";
import { useState } from "react";
import axios from "axios";
import { CircularProgress } from "@mui/material";

function AddNewPrice() {
  const [formData, setFormData] = useState({});
  const [isLoading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    let valid = true;
    const newErrors = {};

    if (!formData.trainSizePrice) {
      newErrors.trainSizePrice = " Train Size Price is required";
      style = {
        color: "red",
      };
      valid = false;
    }

    if (!formData.trainWeightPrice) {
      newErrors.trainWeightPrice = "Train Weight Price is required";
      valid = false;
    }

    if (!formData.airWeightPrice) {
      newErrors.airWeightPrice = "Air Weight Price is required";
      valid = false;
    }

    if (!formData.tax) {
      newErrors.tax = "Tax is required";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const dataSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setLoading(true);
    await axios.post(
      `${process.env.REACT_APP_BASE_URL}/deliveryPrice/createDeliveryPrice`,
      formData
    );
    setFormData({});
    setLoading(false);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar/>
      <MDBox py={3}>
        <form
          style={{
            background: "white",
            padding: "10px",
            borderRadius: "10px",
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
          }}
          autoComplete="off"
          action=""
          onSubmit={dataSubmit}
        >
          <div style={{ padding: "5px" }}>
            <div style={{ display: "flex", gap: "40px" }}>
              <TextField
                id="outlined-basic"
                name="countries"
                sx={{ width: "20vw" }}
                label="Countries*"
                variant="outlined"
                value={formData.countries}
                onChange={(e) => setFormData({ ...formData, [e.target.name]: e.target.value })}
                required
              />
              <TextField
                id="outlined-basic"
                sx={{ width: "20vw" }}
                label="Region*"
                name="region"
                variant="outlined"
                value={formData.region}
                onChange={(e) => setFormData({ ...formData, [e.target.name]: e.target.value })}
                required
              />
              <TextField
                type="number"
                id="outlined-basic"
                sx={{ width: "20vw" }}
                label="Train Size Price*"
                variant="outlined"
                name="trainSizePrice"
                value={formData.trainSizePrice}
                onChange={(e) => setFormData({ ...formData, [e.target.name]: e.target.value })}
                required
                error={!!errors.trainSizePrice}
                helperText={errors.trainSizePrice}
              />
            </div>
            <div style={{ display: "flex", gap: "40px", marginTop: "5vh" }}>
              <TextField
                type="number"
                id="outlined-basic"
                sx={{ width: "20vw" }}
                label="Train Weight Price*"
                variant="outlined"
                name="trainWeightPrice"
                value={formData.trainWeightPrice}
                onChange={(e) => setFormData({ ...formData, [e.target.name]: e.target.value })}
                required
                error={!!errors.trainWeightPrice}
                helperText={errors.trainWeightPrice}
              />
              <TextField
                type="number"
                id="outlined-basic"
                sx={{ width: "20vw" }}
                label="Air Size Price"
                variant="outlined"
                name="airSizePrice"
                value={formData.airSizePrice}
                onChange={(e) => setFormData({ ...formData, [e.target.name]: e.target.value })}
                required
                error={!!errors.airSizePrice}
                helperText={errors.airSizePrice}
              />
              <TextField
                type="number"
                id="outlined-basic"
                sx={{ width: "20vw" }}
                label="Air Weight Price*"
                variant="outlined"
                name="airWeightPrice"
                value={formData.airWeightPrice}
                onChange={(e) => setFormData({ ...formData, [e.target.name]: e.target.value })}
                required
                error={!!errors.airWeightPrice}
                helperText={errors.airWeightPrice}
              />
            </div>
            <div style={{ display: "flex", gap: "40px", marginTop: "5vh" }}>
              <TextField
                type="number"
                id="outlined-basic"
                sx={{ width: "20vw" }}
                label="Tax*"
                variant="outlined"
                name="tax"
                value={formData.tax}
                onChange={(e) => setFormData({ ...formData, [e.target.name]: e.target.value })}
                required
                error={!!errors.tax}
                helperText={errors.tax}
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "10vh",
            }}
          >
            <button
              variant="contained"
              style={{
                color: "white",
                padding: "10px",
                cursor: "pointer",
                border: "none",
                outline: "none",
                background: "crimson",
                borderRadius: "5px",
              }}
            >
              {isLoading ? (
                <>
                  <CircularProgress color="inherit" size={14} sx={{ color: "white" }} />
                  Submit
                </>
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </form>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AddNewPrice;
